(function() {
  require(["jquery", "underscore", "commons/reachCharts", "commons/basicInfoCharts", "dataTables", "bootstrap-collapse"], function($, _, reachCharts, basicInfoCharts) {
    return $(function() {
      var mediaId;
      mediaId = $('#MediaId').val();
      reachCharts.executePrint("#PageViewsDataUri", "reach-chart");
      basicInfoCharts.executeGenderChart("" + mediaId, "#gender_chart");
      return basicInfoCharts.executeAgeChart("" + mediaId, "#age_chart", "basicinfo-agechart");
    });
  });

}).call(this);

//# sourceMappingURL=appPrint.js.map
;
define("Apps/Reach/script/appPrint", function(){});

